var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path201",
    d: "M0-682.665H28v28H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g195",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g197",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g199",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g205",
    transform: "translate(1.094 1.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path207",
    d: "M-276.613-478.212h2.151m4.315,0H-268m-15.07,0h2.151m4.3-6.453h2.151m4.315,0H-268m-15.07,0h2.151m-7.529-5.4h25.825m-21.51,17.208h17.2a4.315,4.315,0,0,0,4.314-4.315V-492.2a4.315,4.315,0,0,0-4.314-4.315h-17.2a4.315,4.315,0,0,0-4.314,4.315v15.032A4.315,4.315,0,0,0-284.129-472.853Zm15.057-20.435v-5.378m-12.919,5.378v-5.378",
    transform: "translate(288.443 498.665)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico_calendar.c64043c944c5f281a0438a202c0bb845.svg";
export { ForwardRef as ReactComponent };